import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { CLIENT_LOADED } from "../constants/actionTypes";
import * as agent from "../agent";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import OuterLink from './OuterLink';
import InnerLink from './InnerLink';

class securityNKBI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestingNKBI: false,
            fetchingNKBI: false,
            submitRequestDisabled: false,
            submitFetchDisabled: false,
            requestError: false,
            requestErrorMessage: ""
        }
    }
    requestNKBI = () => {
        if(window.confirm("Подтвердите запрос платной проверки")) {
            this.setState({ submitRequestDisabled: true, requestingNKBI: true });
            const { carId, clientDetails, dispatch } = this.props;
            agent.Clients.nkbiRequest(carId, clientDetails)
                .then(client => {
                    dispatch({type: CLIENT_LOADED, payload: client});
                    this.setState({ requestingNKBI: false });
                })
                .catch(err => {
                    this.setState({ requestError: true, requestErrorMessage: err.message, requestingNKBI: false })
                })
        }
    }

    fetchNKBI = () => {

        this.setState({ submitFetchDisabled: true, fetchingNKBI: true });
        const { carId, nkbiRequestId, dispatch } = this.props;

        agent.Clients.nkbiFetch(carId, nkbiRequestId)
            .then(client => {
                dispatch({type: CLIENT_LOADED, payload: client});
                this.setState({ fetchingNKBI: false });
            })
            .catch(err => {
                this.setState({ fetchError: true, fetchErrorMessage: err.message, fetchingNKBI: false })
            })
    }
    render() {
        const { isNKBIRequested,
                isNKBIFetched,
                nkbiReportLink,
                nkbiRequestDate,
                nkbi = {},
                hasContract,
                clientDetails: {
                    lastname,
                    firstname,
                    patronymic,
                    birthDate,
                    passportSerie,
                    passportNumber,
                    passportDate
                } = {},
                clientId,
                carId } = this.props;
        const { requestingNKBI, fetchingNKBI, submitRequestDisabled, submitFetchDisabled, requestError, requestErrorMessage, fetchError, fetchErrorMessage } = this.state;

        const findRealLength = str => (str||"").replace(/\D/g,"").length;

        const isEmptyFields = [lastname, firstname, patronymic].some(f => (f||"").length === 0) ||
                              findRealLength(birthDate) !== 8 ||
                              findRealLength(passportDate) !== 8 ||
                              findRealLength(passportSerie) !== 4 ||
                              findRealLength(passportNumber) !== 6;

        return (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16} style={{ marginTop: 20, marginBottom: 20 }}>
                {requestError &&
                    <Grid item>
                        <Typography paragraph>Возникла ошибка при выполнении запроса: {requestErrorMessage}. Устраните ее и повторите попытку</Typography>
                    </Grid>
                }
                {fetchError &&
                    <Grid item>
                        <Typography paragraph>Возникла ошибка при попытке получить результат: {fetchErrorMessage}</Typography>
                    </Grid>
                }
                {!isNKBIRequested && !isNKBIFetched && requestingNKBI &&
                    <Grid item>
                        <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                        <CircularProgress />
                    </Grid>
                }
                {!isNKBIRequested && !isNKBIFetched &&
                    <Grid item>
                        <Typography paragraph >Запрос информации от сервиса promoneyclub не производился. Проверьте и при необходимости {hasContract ? <InnerLink target="_blank" href={`/client/${clientId}/editcontract/${carId}`} label="отредактируйте" /> : "отредактируйте" } данные клиента перед запросом:</Typography>
                    </Grid>
                }
                {!isNKBIRequested && !isNKBIFetched &&
                    <Grid item>
                        <Typography paragraph >Фамилия: '{lastname}'</Typography>
                        <Typography paragraph>Имя: '{firstname}'</Typography>
                        <Typography paragraph>Отчество: '{patronymic}'</Typography>
                        <Typography paragraph>Дата рождения: '{birthDate}'</Typography>
                        <Typography paragraph>Серия паспорта: '{passportSerie}'</Typography>
                        <Typography paragraph>Номер паспорта: '{passportNumber}'</Typography>
                        <Typography paragraph>Дата выдачи паспорта: '{passportDate}'</Typography>
                        <Button type="submit"
                                onClick={this.requestNKBI}
                                disabled={submitRequestDisabled || isEmptyFields}
                                size="large"
                                color="primary"
                                variant="contained"> Запрос информации </Button>
                    </Grid>
                }
                {isNKBIRequested && !isNKBIFetched &&
                    <React.Fragment>
                        {fetchingNKBI &&
                            <Grid item>
                                <Typography paragraph>Отправка запроса. Ожидайте...</Typography>
                            </Grid>
                        }
                        {!fetchingNKBI &&
                            <Grid item>
                                <CircularProgress />
                            </Grid>
                        }
                        {!fetchingNKBI &&
                            <Grid item>
                                <Typography paragraph>Запрос информации был осуществлен {new Date(nkbiRequestDate).toLocaleString()}. В соответствии с регламентом сервиса promoneyclub обработка результатов может занимать до 15 минут рабочего времени</Typography>
                            </Grid>
                        }
                        <Grid item>
                            <Button type="submit"
                                    onClick={this.fetchNKBI}
                                    disabled={submitFetchDisabled}
                                    size="large"
                                    color="primary"
                                    variant="contained"> Запрос результата </Button>
                        </Grid>
                    </React.Fragment>
                }
                {isNKBIRequested && isNKBIFetched &&
                    <React.Fragment>
                        <Grid item>
                            <Typography paragraph>Статус запроса: {nkbi["STATUS|VALUE"] || "Начальный"}</Typography>
                        </Grid>
                        <Grid item>
                            <OuterLink href={nkbiReportLink} label={"Просмотр отчета"}/>
                        </Grid>
                    </React.Fragment>
                }
            </Grid>
        );
    }
};


const SecurityNKBI = connect(null, null)(reduxForm({form: "security-nkbi"})(securityNKBI));

export default SecurityNKBI;



// WEBPACK FOOTER //
// ./src/components/SecurityNKBI.js